import { TranslatePipe, TranslateService } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { RouterModule } from "@angular/router";

import { AliasEditorComponent } from "../../../../components/common/alias-editor/alias-editor.component";
import { TrafficLineChart } from "../../../../components/dashboard/traffic-line-chart/traffic-line-chart.component";
import {
  TrafficSubject,
  makeAllServicesOption,
  makeNamedOption,
} from "../../../../components/dashboard/traffic-line-chart/traffic-line-chart.helpers";
import { PortServicesPanel } from "../../../../components/subscription-detail/port-services-panel/port-services-panel";
import { ServiceId } from "../../../../components/subscription-detail/service-id/service-id";
import { SubscriptionDetailHeader } from "../../../../components/subscription-detail/subscription-detail-header/subscription-detail-header";
import { ThirdPartyServiceIdsRowContentComponent } from "../../../../components/subscription-detail/third-party-service-ids-row-content/third-party-service-ids-row-content";
import { ServiceSpeedPipe } from "../../../../helpers/service-speed-pipe/service-speed-pipe";
import { SubscriptionDatePipe } from "../../../../helpers/subscription-datepipe/subscription-datepipe";
import { MscSubscriptionDetails } from "../../types";
import { SubscriptionViewBase } from "../subscription-view-base";
import { PortShortcutMenu } from "./components/port-shortcut-menu/port-shortcut-menu";

@Component({
  selector: "msc-subscription-view",
  templateUrl: "msc-subscription-view.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AliasEditorComponent,
    TrafficLineChart,
    PortShortcutMenu,
    RouterModule,
    ServiceId,
    ServiceSpeedPipe,
    SubscriptionDatePipe,
    PortServicesPanel,
    SubscriptionDetailHeader,
    ThirdPartyServiceIdsRowContentComponent,
    TranslatePipe,
  ],
})
export class MscSubscriptionViewComponent extends SubscriptionViewBase<MscSubscriptionDetails> {
  protected domain = computed(() => this.subscription().domain);
  protected portMode = computed(() => this.subscription().portMode);
  protected portSpeed = computed(() => this.subscription().portSpeed);
  protected serviceTag = computed(() => this.subscription().serviceTag);
  protected address = computed(() => this.subscription().address);

  private portSubscription = computed(() => this.subscription().portSubscription);
  protected portDescription = computed(() => this.portSubscription()?.description);
  protected portSubscriptionId = computed(() => this.portSubscription()?.subscriptionId);
  protected linkPortSubscription = computed(() => this.portSubscription()?.customerId === this.customerId());

  private translate = inject(TranslateService);
  protected chartSubjects = computed<TrafficSubject[]>(() => [
    makeAllServicesOption(this.portSubscriptionId() ?? "", this.translate),
    ...this.subscription().services.map(makeNamedOption),
  ]);
}
